export default __webpack_public_path__ + "static/media/dots-min.25b2e869.svg";